var render, staticRenderFns
import script from "./doughnut.chart.vue?vue&type=script&lang=js&"
export * from "./doughnut.chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports